// covered-by: frontends/carrie/src/ask-v2/rail/__tests__/AskV2RightRail.test.tsx
import { Badge } from "@radix-ui/themes";
import { useTranslation } from "react-i18next";

import { type AskV2RailDocument } from "./types";

import { DocumentDownloadRow } from "../../components/DocumentDownloadRow";

export function AskV2RailDocumentCard({
  document,
}: {
  document: AskV2RailDocument;
}) {
  const { t } = useTranslation("ui");
  const testId = `ask-v2-rail-document-${document.fileId}-v${document.versionOrdinal}`;

  return (
    <DocumentDownloadRow
      url={document.source}
      name={document.name}
      fileType={document.type}
      testId={testId}
      tooltipSide="left"
      ariaLabel={
        document.showVersionBadge
          ? t("campaignDocsPanel.downloadFileVersion", {
              name: document.name,
              version: document.versionOrdinal,
            })
          : t("campaignDocsPanel.downloadFile", { name: document.name })
      }
      trailing={
        document.showVersionBadge ? (
          <Badge
            size="1"
            variant="soft"
            color="gray"
            className="shrink-0"
            data-testid={`${testId}-version`}
          >
            V{document.versionOrdinal}
          </Badge>
        ) : null
      }
    />
  );
}
